<template>
  <MobileAuth
    ref="mobileAuth"
    :authType="'EMAIL'"
    :isExistBtnMsg="true"
    :formTitle="'이메일'"
    :formSubTitle="'(등록/변경)'"
    :actionType="'SET'"
  >
    <template v-slot:titleArea>
      <div v-if="currentEmail" class="con_ttl top10">
        등록된 이메일<br />{{ currentEmail }}
      </div>
    </template>

    <template v-slot:msgArea>
      <div class="msg left">
        <div class="light_color bold">※ 안내사항</div>
        <br />
        <div class="light_color">
          - 휴대폰 번호가 변경될 예정이라면 이메일 등록을 해주세요.
        </div>
        <div class="light_color" style="word-break:keep-all;">
          - 이메일 등록 후 '로그인/회원가입' 화면의 이메일 인증을 통해 휴대폰
          번호를 변경할 수 있습니다.
        </div>
      </div>
    </template>

    <template v-slot:btnArea="btnAreaProps">
      <div class="btm_btn">
        <button
          style="border-radius: 0;"
          class="btn"
          :disabled="!btnAreaProps.isAvailable"
          @click="registration()"
        >
          저장하기
        </button>
      </div>
    </template>
  </MobileAuth>
</template>
<script>
import MobileAuth from '../auth/components/MobileAuth';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonTypes from '@common/store/modules/common/types';
import { authTypes } from '@common/store/modules';
export default {
  components: {
    MobileAuth,
  },
  data() {
    return {
      currentEmail: '',
    };
  },
  mounted() {
    this.currentEmail = this.emailMasking(this.user.email);
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
  },
  methods: {
    ...userMapActions([userTypes.EXIST_EMAIL, userTypes.UPDATE_EMAIL_ME]),
    ...commonMapActions([commonTypes.SET_DIALOG, commonTypes.HIDE_DIALOG]),
    emailMasking(email) {
      let maskingEmail = email
        ? email.toString().replace(new RegExp('.(?=.{0,2}@)', 'g'), '*')
        : '';

      return maskingEmail;
    },
    registration() {
      this.$refs.mobileAuth.handleAuthConfirm((email, authNumber) => {
        this[userTypes.EXIST_EMAIL](email)
          .then(() => {
            let params = {
              code: authNumber,
              email: email,
            };
            this[userTypes.UPDATE_EMAIL_ME](params)
              .then(() => {
                this[commonTypes.SET_DIALOG]({
                  type: 'alert',
                  icon: 'warning',
                  message: `저장되었습니다.`,
                  okCb: async () => {
                    this.currentEmail = this.emailMasking(email);
                    await this.$router.push({ name: 'MyPage.Main' });
                  },
                });
              })
              .catch(() => {});
          })
          .catch(() => {});
      });
    },
  },
};
</script>
